// extracted by mini-css-extract-plugin
export default {"page":"Main_page__F4fcX","illuminator":"Main_illuminator__SuJxt"};